<router-outlet ngxUiLoaderBlurred></router-outlet>

<ngx-ui-loader
  [fgsType]="'three-strings'"
  [fgsColor]="'#25476a'"
  [fgsSize]="100"
  [overlayColor]="'rgb(159 159 159 / 70%)'"
  [logoUrl]="'assets/images/logo-xpresion.png'"
  [logoSize]="30"
  class="custom-loader">
</ngx-ui-loader>
